// extracted by mini-css-extract-plugin
module.exports = {"CarouselArrow":"LeftArrow-module--CarouselArrow--25tN8","ArrowSvgLeft":"LeftArrow-module--ArrowSvgLeft--Dc9C3"};